import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useOutletContext } from 'react-router'
import { Link, useParams } from 'react-router-dom'
import CreateGroupLearningAssignmentsForm from '../../components/learningAssignmentForms/CreateGroupLearningAssignmentsForm/CreateGroupLearningAssignmentsForm'
import useRoutes from '../../state/useRoutes'

export default React.memo(function CreateGroupLearningAssignmentsPage() {
  const { uuid } = useParams()
  const uuids = useMemo(() => [uuid!], [uuid])
  const { pathsOrCourses } = useParams()

  const { close } = useOutletContext<any>()

  return <CreateGroupLearningAssignmentsForm groupUuids={uuids} onClose={close} pathsOrCourses={pathsOrCourses === '1'}/>
})

export function CreateGroupLearningAssignmentsPageBreadcrumb() {
  const { uuid } = useParams()
  const { t } = useTranslation()
  const routes = useRoutes()
  return (
    <Link to={routes.createGroupLearningAssignments.url({ uuid: uuid!, pathsOrCourses: null  })}>
      {t('manage learning.create learning assignments')}
    </Link>
  )
}
